import { Outlet, useLocation } from "react-router-dom";
import Footer from "./Footer";
import Main from "./Main";
import SideBar from "./SideBar";
import { useEffect, useMemo, useState } from "react";
import { themeColor } from "../../lib/themeColor";
import { createContext } from "react";

export const UserContext = createContext<any>({ user: {}, setUser: () => {} });

const getCookie = () => {
  let userdata: { [key: string]: any } = {};
  const cookies = Object.fromEntries(document.cookie.split("; ").map((c) => c.split("=")));
  if (cookies.user) {
    userdata = JSON.parse(decodeURIComponent(cookies["user"]));
  }
  return userdata;
};

export default function Root() {
  const [user, setUser] = useState<{ [key: string]: any }>({});
  const location = useLocation();
  // console.log(user);
  useMemo(() => {
    setUser(getCookie());
  }, []);

  useEffect(() => {
    themeColor(user);
  }, [location.pathname]);

  useEffect(() => {
    document.cookie = `user=${encodeURIComponent(JSON.stringify(user))}; path=/;`;
  }, [user.theme, user.theme_color_hs]);

  return (
    <UserContext value={{ user, setUser }}>
      <SideBar />
      <Main>
        <Outlet />
      </Main>
      <Footer />
    </UserContext>
  );
}
